import { restaurantSchema } from '../schemas/restaurant/restaurantSchema';

export const restaurantsGeneralInfo = restaurantSchema
  .pick({ address: true, postcode: true, phone: true, abn: true })
  .decode({
    address: '60 Moorabool Street',
    postcode: '3220',
    phone: '(03) 4250 9750',
    abn: '41 835 105 835',
  });
